/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { motion } from "framer-motion";

/* APIS */
import { getBlogs } from "../service/api";

/* CONFIG */
import { AGENT_ID, IMAGE_URL } from "../config";

const BlogBox = (props) => {
  return (
    <Link
      to={"/blog-detail/" + props?.blogDetails?._id}
      style={{ textDecoration: "none" }}
    >
      <Card className="blog-box">
        <Card.Body className="blog-box-body">
          <img src={IMAGE_URL + props?.image} alt={props.blogTitle} />
          <div className="details">
            <h5>{props.title}</h5>
          </div>
        </Card.Body>
      </Card>
    </Link>
  );
};

const Blogs = () => {
  /* STATE VARIABLES */
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [blogsData, setBlogsData] = useState([]);

  /* GET BLOGS LISTINGS */
  const getBlogsList = () => {
    setLoading(true);
    const obj = {};
    obj.page = page;
    obj.sizePerPage = pageSize;
    obj.userId = AGENT_ID;

    getBlogs(obj)
      .then((res) => {
        if (res?.status) {
          setBlogsData(res?.data?.docs);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally((err) => {
        setLoading(false);
      });

    return () => {
      setBlogsData([]);
    };
  };

  /* GET BLOGS ONLOAD */
  useEffect(() => {
    getBlogsList();
  }, []);

  useEffect(() => {
    getBlogsList();
  }, [page]);

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="blogs-2"
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-sm-12">
            <div className="heading">
              <h2>THE MOST RECENT LOCAL REAL ESTATE NEWS</h2>
            </div>
          </div>
        </div>
        <div className="row gy-4 mt-2">
          {blogsData.slice(0, 4).map((blog) => {
            return (
              <div className="col-xl-3 col-md-6 col-sm-12">
                <BlogBox
                  image={blog?.image}
                  title={blog?.name}
                  blogDetails={blog}
                />
              </div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
};

export default Blogs;
